import {
  Activity,
  BarChart3,
  Building,
  Building2,
  CalendarPlus,
  Hotel,
  LayoutDashboard,
  Settings,
  UserCheck,
  Users,
} from "lucide-react";

export const modules = [
  { id: "dashboard", label: "Dashboard", header: "Front Office Dashboard", icon: LayoutDashboard },
  { id: "property", label: "Property", icon: Building },
  { id: "roomBooking", label: "Booking", icon: CalendarPlus },
  { id: "roomMaster", label: "Rooms", icon: Hotel },
  { id: "agent", label: "Agent", icon: UserCheck },
  { id: "staff", label: "Staff", icon: Users },
  { id: "tenant", label: "Tenant", icon: Building2 },
  { id: "reports", label: "Reports", icon: BarChart3 },
  { id: "loginActivity", label: "Login Activity", icon: Activity },
  { id: "settings", label: "Settings", icon: Settings },
];
